<template>
    <form-modal
        name="edit-router-settings"
        :primary-button-text="lang('Spara','Save')"
        primary-button-class="is-primary"
        :title="lang('Ändra wifi-inställningar','Change wifi settings')"
        :action="actionUrl"
        :callback="success"
        method="patch"
        @before-open="beforeOpen"
        @before-close="beforeClose"
    >
        <div>
            <text-input
                v-model="ssid"
                name="ssid"
                :label="lang('Nätverksnamn (SSID)','Network name (SSID)')"
            />

            <select-input
                v-model="channel"
                name="channel"
                :options="availableChannels"
            >
                {{ lang('Kanal','Channels') }}
            </select-input>

            <a
                v-if="! showPasswordFields"
                class="block mb-lg"
                href="#"
                @click="changePassword"
            >
                {{ lang('Vill du även ändra lösenordet','Are you sure you want to change password') }}?
            </a>

            <div v-if="showPasswordFields">
                <text-input
                    v-model="password"
                    type="password"
                    name="password"
                    :label="lang('Lösenord','Password')"
                    :validations="'required|min:8|max:32'"
                />

                <text-input
                    v-model="password_confirmation"
                    type="password"
                    name="password_confirmation"
                    :label="lang('Upprepa lösenord','Repeat password')"
                    :validations="'required|min:8|max:32'"
                />
            </div>
        </div>
    </form-modal>
</template>

<script>
    export default {
        data() {
            return {
                band: '24ghz',
                routerSettings: {},
                availableChannels: {},
                ssid: '',
                channel: 0,
                password: '',
                password_confirmation: '',
                showPasswordFields: false,
            };
        },
        computed: {
            actionUrl() {
                if (this.band === '5ghz') {
                    return route('front.my-pages.api.router-settings.update5ghz');
                }

                return route('front.my-pages.api.router-settings.update24ghz');
            },
        },
        methods: {
            beforeOpen(event) {
                this.routerSettings = event.params.routerSettings;
                this.availableChannels = event.params.availableChannels;
                this.band = event.params.editBand;

                if (this.band === '5ghz') {
                    this.ssid = this.routerSettings['5ghz'].ssid;
                    this.channel = this.routerSettings['5ghz'].channel;

                    return;
                }

                this.ssid = this.routerSettings['24ghz'].ssid;
                this.channel = this.routerSettings['24ghz'].channel;
            },
            beforeClose() {
                this.showPasswordFields = false;
            },
            changePassword() {
                this.showPasswordFields = true;
            },
            success() {
                return this.$emit('success', {
                    ssid: this.ssid,
                    channel: this.channel,
                    band: this.band,
                });
            },
        },
    };
</script>
